export enum InvitationStatus {
    Available = 0,
    Deprecated = 1,
    NonExisting = 2
}